import React from 'react';
import { H3 } from 'scy/text';
import margin from 'scy/margin.mod.scss';
import { textCenter } from 'scy/utils.mod.scss';

export default function VerifyMobileHeader() {
  return (
    <H3
      tag="h1"
      marginClass={`${margin.top_0} ${margin.bottom_xs}`}
      className={textCenter}
    >
      Verify Mobile
    </H3>
  );
}
